import type { RouteObject } from "react-router-dom";

export const integrationMetricsRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Return Integration Metrics" },
    async lazy() {
      const { Page } = await import("../../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { IntegrationMetricsPage } =
            await import("./integration-metrics-page");
          return { Component: IntegrationMetricsPage };
        },
      },
    ],
  },
];
